import moment from 'moment';
import React from 'react';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined';
import MilitaryTechRoundedIcon from '@mui/icons-material/MilitaryTechRounded';
import NotesIcon from '@mui/icons-material/Notes';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';

import { OrgChartIcon } from 'common/components/image';
import { ExploreTabEnum } from 'common/enum/ExploreTab.enum';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import { FeaturesEnum } from 'features/feature-access/features.enum';

export type ExploreOrganizationTabType = {
  value: string;
  label: string;
  pathName: string;
  defaultIcon?: React.FC<any>;
  activeIcon?: React.FC<any>;
  IconComponent?: React.FC<any>;
  adminOnly?: boolean;
  badgeLabel?: string;
  feature?: FeaturesEnum;
  contentType?: ExploreTabEnum;
};

export const ExploreOrganizationTabsConfig: { [tab: string]: ExploreOrganizationTabType } = {
  PEOPLE: {
    value: 'people/card',
    label: 'People',
    pathName: AppRoutesEnum.EXPLORE_PEOPLE,
    defaultIcon: GroupsOutlinedIcon,
    activeIcon: GroupsIcon,
    feature: FeaturesEnum.OTHER_PROFILE,
    contentType: ExploreTabEnum.PEOPLE,
  },
  ORG_CHART: {
    value: '',
    label: 'Org Chart',
    pathName: AppRoutesEnum.ORG_CHART_ROOT,
    IconComponent: OrgChartIcon,
    adminOnly: false,
    feature: FeaturesEnum.ORG_CHART,
  },
  OPPORTUNITIES: {
    value: 'opportunities',
    label: 'Opportunities',
    pathName: AppRoutesEnum.EXPLORE_OPPORTUNITIES,
    defaultIcon: BusinessCenterOutlinedIcon,
    activeIcon: BusinessCenterIcon,
    feature: FeaturesEnum.OPPORTUNITIES,
    contentType: ExploreTabEnum.OPPORTUNITIES,
  },
  PRAISE: {
    value: 'praise',
    label: 'Praise',
    pathName: AppRoutesEnum.EXPLORE_PRAISE,
    defaultIcon: MilitaryTechOutlinedIcon,
    activeIcon: MilitaryTechRoundedIcon,
    feature: FeaturesEnum.PRAISES,
    contentType: ExploreTabEnum.PRAISE,
  },
  COMPANY_UPDATES: {
    value: 'company-updates',
    label: 'Company Updates',
    pathName: AppRoutesEnum.EXPLORE_COMPANY_UPDATES,
    defaultIcon: PostAddRoundedIcon,
    activeIcon: PostAddRoundedIcon,
    feature: FeaturesEnum.ALL_COMPANY_UPDATES,
    contentType: ExploreTabEnum.COMPANY_UPDATES,
  },
  EVENTS: {
    value: `events/following/month/${moment().format('MMM')}/${moment().format('YYYY')}`,
    label: 'Events',
    pathName: AppRoutesEnum.EXPLORE_EVENTS,
    defaultIcon: EventNoteOutlinedIcon,
    activeIcon: EventNoteOutlinedIcon,
    adminOnly: false,
    feature: FeaturesEnum.ALL_ORGANIZATION_EVENTS,
    contentType: ExploreTabEnum.ORGANIZATION_EVENTS,
  },
  VIDEOS: {
    value: 'videos',
    label: 'Videos',
    pathName: AppRoutesEnum.EXPLORE_VIDEOS,
    defaultIcon: VideocamOutlinedIcon,
    activeIcon: VideocamOutlinedIcon,
    feature: FeaturesEnum.ALL_COMPANY_UPDATES,
    contentType: ExploreTabEnum.COMPANY_UPDATES,
  },
  // QUICK_LINKS: {
  //   value: 'quick-links',
  //   label: 'Quick Links',
  //   pathName: AppRoutesEnum.EXPLORE,
  //   defaultIcon: LinkIcon,
  //   activeIcon: LinkIcon,
  // },
  WIN_LIST: {
    value: 'win-lists',
    label: 'WIN List',
    pathName: AppRoutesEnum.EXPLORE_WIN_LISTS,
    defaultIcon: NotesIcon,
    activeIcon: NotesIcon,
    feature: FeaturesEnum.WINS,
    contentType: ExploreTabEnum.WIN_LIST,
  },
  ACTIVITIES: {
    value: 'activities',
    label: 'Activities',
    pathName: AppRoutesEnum.ACTIVITIES,
    defaultIcon: PlaylistAddCheckOutlinedIcon,
    activeIcon: PlaylistAddCheckIcon,
    feature: FeaturesEnum.ACTIVITIES,
    contentType: ExploreTabEnum.ACTIVITIES,
  },
};
